export const environment = {
  production: true,
  i18n: {
    baseUrl: 'https://i18n.buildigo.ch/i18n/web-ui/master',
  },
}
